export const getCaptchaResponse = (state: Record<string, any>) => {
  const {
    ui: {
      captcha: { response },
    },
  } = state;

  return response;
};
